import { useReducer } from 'react';

import { IState, StoreAction, initialState, reducer } from '../../ducks/stores';

export const useStoresReducer = (): IState & {
  storeLocatorDispatch: StoreAction;
} => {
  const [
    {
      storesNearby,
      storesFavs,
      storesRecent,
      searchingFavs,
      searchingNearby,
      searchingRecent,
      ...state
    },
    storeLocatorDispatch,
  ] = useReducer(reducer, initialState);

  return {
    ...state,
    searchingFavs: searchingFavs || !storesFavs,
    searchingNearby: searchingNearby || !storesNearby,
    searchingRecent: searchingRecent || !storesRecent,
    storeLocatorDispatch,
    storesFavs,
    storesNearby,
    storesRecent,
  };
};
